<!-- don't remove userTabClickNuller -->
<div class=" userTabClickNuller ui-avatar-container flex center justify-center {{ big ? 'big' : '' }}">
		@if(imagePath && imagePath.length){
			<img [src]="imagePath" (error)="errorHandler()" class="userTabClickNuller" />
		}@else{
			<span class="userTabClickNuller">{{ innerText ? innerText : '' }}</span>
		}
</div>
